import CrmTranslateText from './translate-text'

export { CrmTranslateText }
